import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import UtilService from '../../common/services/util.service';
import {UserResponse} from '../../common/services/user/user.model';
import 'jquery-ui/ui/widgets/autocomplete';
import FamilyPlanService from '../famil-plan.service';
import { OpenMemberRegistrationAction } from '../family-plan-member-registration-dialog/family-plan-member-registration-dialog.action';
import UserService from '../../common/services/user/user.service';
import { OpenStartListenAction } from '../family-plan-member-start-listen-dialog/family-plan-member-start-listen-dialog.action';
import { ITimeoutService, IIntervalService } from 'angular';
import { OpenAboutDialogAction } from '../family-plan-about-dialog/family-plan-about-dialog.action';
import { FamilyPlanTypes } from '../../common/services/package/package.model';

/* @ngInject */
export default class familPlanController {
  public user: UserResponse;
  private familyPlanGetMemberInfoForm: any;
  private addressChange: any;
  private masterToken: string;
  private selectedAddress: any;
  public masterName:string;
  public masterMsisdn:string;
  public toggUser : boolean;

  private today = new Date();
  private currentYear = this.today.getFullYear();
  private minYear = new Date(this.today.setFullYear(this.today.getFullYear() - 130)).getFullYear();
  private years = [];
  private type: FamilyPlanTypes;
  private isValidEmail:boolean;

  public emailCode: string;
  public isEmailVerified: boolean = false;
  public emailOtpSent: boolean = false;
  public isReqSend: boolean = false;
  public otpErrorMessage: any;
  public time: string = '03:00';
  public resendDisabled: boolean = true;
  public emailForOtp: string = '';
  private timer: any = null;

  constructor(
    private $element,
    private $state,
    private $stateParams,
    private $timeout: ITimeoutService,
    private $interval: IIntervalService,
    private actionDispatcher: ActionDispatcherService,
    private familyPlanService: FamilyPlanService,
    private userService: UserService
  ) {

  }

  public $onInit() {
    this.type = this.$state.current.name.includes('duo') ? FamilyPlanTypes.DUO : FamilyPlanTypes.FAMILY;
    this.loadVerifiedEmailFromSession();
    this.checkUser();
    this.getMasterName();
    for (var i = this.currentYear; i >= this.minYear; i--) {
      this.years.push(i);
    }
    angular.element(document).ready(() => {
      if(this.type == FamilyPlanTypes.FAMILY) {
        this.addressAutoComplete();
      }
      this.checkedValid();
    });

  }

  public checkUser(){
    this.userService.getUserInfo().then(user => {
      this.user = user;
      this.user.email=this.user.email=='null'?'':this.user.email;
      this.isValidEmail=this.checkedEmailValid(this.user.email);
      this.familyPlanService.getFamilyPlanInfo(this.type).then(result => {
        if(result){
          this.$state.go('familyPlanMemberInfo');
        }
      });
   });
  }

  public getMasterName(){
    this.masterToken = this.$stateParams.masterToken;
    this.familyPlanService.getMasterInfoByToken(this.masterToken).then(result => {
      this.masterName = result.name;
      this.masterMsisdn = result.msisdn;
      this.toggUser = result.toggUser;
      if(this.toggUser){
        const savedButton = angular.element('#fp-saved-infos');
        savedButton.removeAttr('disabled');
      }
    });
  }

  public checkedValid() {
    this.familyPlanGetMemberInfoForm = this.$element.find("#familyPlanGetMemberInfoForm");
    this.familyPlanGetMemberInfoForm.on('change', (event) => {
      this.updateSaveButtonState();
    });
  }

  private updateSaveButtonState() {
    const savedButton = angular.element('#fp-saved-infos');
    const emailPreVerified = this.toggUser && this.isValidEmail;
    const isFormValid = this.familyPlanGetMemberInfoForm[0].checkValidity();
    const emailVerified = emailPreVerified || this.isEmailVerified;
    if (isFormValid && emailVerified) {
      savedButton.removeAttr('disabled');
    } else {
      savedButton.attr('disabled', 'disabled');
    }
  }

  public checkedEmailValid(email:any): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  public addressAutoComplete() {
    this.addressChange = angular.element('#address');
    var self = this;
    self.autoComplete(self, '');
    this.addressChange.bind('paste keyup', function (evnt)  {
      self.$timeout(() => {
        let addressinputval =  evnt.target.value;
        self.autoComplete(self, addressinputval)
       , 500
      });
  });
  };

  private autoComplete(self: this, addressinputval: any) {
    return $("#address").autocomplete({
      source: function (request, response) {
        self.familyPlanService.addressAutoComplete(addressinputval).then(result => {
          response(result);
        });
      },
      create: function () {
      },
      select: function (event, ui) {
        let address = [];
        for (let i = 0; i < 16; i++) {
          address.push(ui.item[i]);
        }

        self.selectedAddress = address;
        $("#address").val(ui.item[0]);
        if (self.$element.find('#familyPlanGetMemberInfoForm')[0].checkValidity()) {
          angular.element('#fp-saved-infos').removeAttr('disabled');
        }
        return false;

      }
    })
      .data("ui-autocomplete")._renderItem = function (ul, item) {
        return $("<li>")
          .append("<div class='crspointer'>" + item[0] + "</div>")
          .appendTo(ul);
      };
  }

  public saveInfo(form: any) {
    const emailPreVerified = this.toggUser && this.isValidEmail;
    if ((form.$valid == true || this.toggUser) && (emailPreVerified || this.isEmailVerified)) {
      this.otpErrorMessage = null;
      let strBirthDate;
      if (this.toggUser) {
        strBirthDate = null;
        this.selectedAddress = null;
      } else {
        const daylVal = this.familyPlanGetMemberInfoForm[0].elements.day.value;
        const monthlVal = this.familyPlanGetMemberInfoForm[0].elements.month.value;
        const yearlVal = this.familyPlanGetMemberInfoForm[0].elements.year.value;
        strBirthDate = daylVal + monthlVal + yearlVal;
      }
      const emailVal = this.user.email || this.emailForOtp;

      //this.actionDispatcher.dispatch(new OpenMemberRegistrationAction(strBirthDate, emailVal, this.selectedAddress, this.masterToken, this.type));
      this.familyPlanService.joinFamilyPlan(strBirthDate, emailVal, this.selectedAddress, this.masterToken, this.type).then(result => {
        if(result){
          this.actionDispatcher.dispatch(
            new OpenStartListenAction(this.type)
          );
        }
      });
    } else if (!form.$valid || (!emailPreVerified && !this.isEmailVerified)) {
      if (!emailPreVerified && !this.isEmailVerified) {
        this.otpErrorMessage = 'familyPlan.otp.pleaseVerify';
      }
    }
  }

  public onAbout(){
    this.actionDispatcher.dispatch(new OpenAboutDialogAction(this.type));
  }

  public isDuoPackage() {
    return this.type == FamilyPlanTypes.DUO;
  }

  public sendEmailOtp() {
    const email = this.familyPlanGetMemberInfoForm[0].elements.email.value;
    if (!this.checkedEmailValid(email)) {
      return;
    }
    this.emailForOtp = email;
    this.isReqSend = true;
    this.otpErrorMessage = null;
    this.familyPlanService.sendEmail(email, this.type).then(() => {
      this.isReqSend = false;
      this.emailOtpSent = true;
      this.startTimer();
    }, (error) => {
      this.isReqSend = false;
      this.otpErrorMessage = 'familyPlan.otp.sendError';
    });
  }

  public validateEmailOtp() {
    const email = this.emailForOtp || this.familyPlanGetMemberInfoForm[0].elements.email.value;
    if (!this.emailCode || this.emailCode.trim().length === 0) {
      this.otpErrorMessage = 'familyPlan.otp.empty';
      return;
    }
    this.isReqSend = true;
    this.otpErrorMessage = null;
    this.familyPlanService.validateEmail(email, this.emailCode, this.type).then(() => {
      this.isReqSend = false;
      this.isEmailVerified = true;
      this.emailOtpSent = false;
      this.saveVerifiedEmailToSession(email);
      this.resetTimer();
      this.updateSaveButtonState();
    }, (error) => {
      this.isReqSend = false;
      this.otpErrorMessage = 'familyPlan.otp.sendError';
      this.emailCode = '';
      this.emailOtpSent = false;
      this.resetTimer();
      this.updateSaveButtonState();
    });
  }

  public onResendEmailOtp() {
    this.resetTimer();
    this.emailCode = '';
    const email = this.emailForOtp;
    if (!email || !this.checkedEmailValid(email)) {
      this.otpErrorMessage = 'familyPlan.otp.invalidEmail';
      return;
    }
    this.isReqSend = true;
    this.otpErrorMessage = null;
    this.familyPlanService.sendEmail(email, this.type).then(() => {
      this.isReqSend = false;
      this.emailOtpSent = true;
      this.startTimer();
    }, (error) => {
      this.isReqSend = false;
      this.otpErrorMessage = 'familyPlan.otp.sendError';
    });
  }

  public onEmailChange() {
    const currentEmail = (this.user && this.user.email) ? this.user.email : '';
    const verifiedEmail = this.getVerifiedEmailFromSession();

    if (currentEmail && verifiedEmail && currentEmail === verifiedEmail) {
      this.isEmailVerified = true;
      this.emailForOtp = currentEmail;
      this.emailOtpSent = false;
      this.emailCode = '';
      this.otpErrorMessage = null;
      this.resetTimer();
      this.updateSaveButtonState();
    } else if (this.isEmailVerified || this.emailOtpSent) {
      this.isEmailVerified = false;
      this.emailOtpSent = false;
      this.emailCode = '';
      this.emailForOtp = '';
      this.otpErrorMessage = null;
      this.resetTimer();
      this.updateSaveButtonState();
    }
  }

  private startTimer() {
    const countDownDate = new Date().getTime() + 3 * 60 * 1000;
    this.resendDisabled = true;
    this.time = '03:00';
    this.timer = this.$interval(() => {
      const now = new Date().getTime();
      const distance = countDownDate - now;
      const minutes = Math.floor((distance % (1000*60*60)) / (1000*60));
      const seconds = Math.floor((distance % (1000*60)) / 1000);
      if (distance < 0) {
        this.resendDisabled = false;
        this.$interval.cancel(this.timer);
        return;
      }
      this.time = (minutes < 10 ? '0' : '') + minutes + ':' + (seconds > 9 ? seconds : '0' + seconds);
    }, 1000);
  }

  private resetTimer() {
    if (angular.isDefined(this.timer)) {
      this.$interval.cancel(this.timer);
    }
    this.time = '03:00';
    this.resendDisabled = true;
  }

  private loadVerifiedEmailFromSession() {
    const verifiedEmail = this.getVerifiedEmailFromSession();
    if (verifiedEmail) {
      this.emailForOtp = verifiedEmail;
      this.isEmailVerified = true;
      this.emailOtpSent = false;
      if (this.user) {
        this.user.email = verifiedEmail;
      }
    }
  }

  private saveVerifiedEmailToSession(email: string) {
    const baseKey = 'verified_emails';
    const encodedKey = btoa(encodeURIComponent(baseKey));
    const existingData = this.getVerifiedEmailsFromSession();
    if (existingData.indexOf(email) === -1) {
      existingData.push(email);
    }
    const jsonData = JSON.stringify(existingData);
    const encoded = encodeURIComponent(jsonData);
    sessionStorage.setItem(encodedKey, btoa(encoded));
  }

  private getVerifiedEmailsFromSession(): string[] {
    const baseKey = 'verified_emails';
    const encodedKey = btoa(encodeURIComponent(baseKey));
    const item = sessionStorage.getItem(encodedKey);
    if (!item) {
      return [];
    }
    try {
      const decoded = decodeURIComponent(atob(item));
      return JSON.parse(decoded);
    } catch (e) {
      return [];
    }
  }

  private getVerifiedEmailFromSession(): string | null {
    const baseKey = 'verified_emails';
    const encodedKey = btoa(encodeURIComponent(baseKey));
    const item = sessionStorage.getItem(encodedKey);
    if (!item) {
      return null;
    }
    try {
      const decoded = decodeURIComponent(atob(item));
      const emails = JSON.parse(decoded);
      return (this.user && this.user.email && emails.indexOf(this.user.email) !== -1) ? this.user.email : null;
    } catch (e) {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/family-plan/family-plan-member/family-plan-member.controller.ts